import React, { useState, useEffect } from 'react';
import { SpotlightTransition } from '@atlaskit/onboarding';
import { Text } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { JiraSpotlight } from '@atlassian/jira-spotlight/src/ui/jira-spotlight.tsx';
import { useSeenStatus } from '@atlassian/jira-servicedesk-itsm-onboarding-common/src/controllers/seen-status/index.tsx';
import spotlightImage from '../../../../common/assets/ai-draft-gen-onboarding.svg';
import { PACKAGE_NAME, TEAM_NAME } from '../../../../common/constants.tsx';
import messages from './messages.tsx';

const Target = 'aiDraftGenChangeBoarding';
const MESSAGE_ID = 'jsm-kb-article-gen-changeboarding';

export const AiDraftGenChangeBoarding = () => {
	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const [{ isSeen: hasSeenSpotlight }, { markAsSeen: markSpotlightAsSeen }] = useSeenStatus({
		userPropertyKey: MESSAGE_ID,
		isSeenValue: true,
		packageName: PACKAGE_NAME,
		teamName: TEAM_NAME,
	});
	const [isSpotlightActive, setIsSpotlightActive] = useState(true);

	useEffect(() => {
		if (!hasSeenSpotlight) {
			fireUIAnalytics(
				createAnalyticsEvent({ action: 'viewed', actionSubject: 'aiDraftGenChangeBoarding' }),
			);
		}
	}, [createAnalyticsEvent, hasSeenSpotlight]);

	const onEndTour = () => {
		markSpotlightAsSeen();
		setIsSpotlightActive(false);
	};

	return (
		!hasSeenSpotlight &&
		isSpotlightActive && (
			<SpotlightTransition>
				<JiraSpotlight
					testId={Target}
					image={spotlightImage}
					heading={formatMessage(messages.spotlightTitle)}
					actions={[
						{
							onClick: onEndTour,
							text: formatMessage(messages.spotlightCta),
						},
					]}
					dialogPlacement="bottom right"
					target={Target}
					targetRadius={3}
					dialogWidth={270}
					messageId="servicedesk-knowledge-performance.ui.suggested-topics-table.create-article.ai-draft-gen-change-boarding.jira-spotlight"
					messageType="transactional"
				>
					<Text as="p">{formatMessage(messages.spotlightDescription)}</Text>
				</JiraSpotlight>
			</SpotlightTransition>
		)
	);
};
